var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "users-container flex hover-border-primary-6-i",
      class: { "multi-line": _vm.multiLine, disabled: _vm.disabled },
      on: {
        click: function ($event) {
          _vm.disabled ? null : _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-1 flex flex-wrap flex-top" },
        [
          _vm._l(_vm.userList, function (item) {
            return _c(
              "yxt-tag",
              {
                key: item.id,
                staticClass: "users-container--tag font-size-12",
                attrs: {
                  size: "small",
                  closable: !_vm.disabled && !_vm.readonly,
                  type: "info",
                },
                on: {
                  close: function ($event) {
                    return _vm.close(item)
                  },
                },
              },
              [
                _c("yxtbiz-user-name", {
                  attrs: { name: item.fullName || item.fullname },
                }),
              ],
              1
            )
          }),
          _vm.userList.length === 0
            ? _c("div", { staticClass: "lh30 ph5 ml8 color-gray-6" }, [
                _vm._v(_vm._s(_vm.placeholder)),
              ])
            : _vm._e(),
        ],
        2
      ),
      !_vm.disabled
        ? _c("div", { staticClass: "mr8 flex flex-mid" }, [
            _c("i", {
              staticClass:
                "size14 color-gray-6 yxt-input__icon yxt-icon-more hand hover-primary-6",
              attrs: { slot: "suffix" },
              slot: "suffix",
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }